"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18n_de_de = void 0;
function i18n_de_de() {
    return {
        "languages.de": "Deutsch",
        "languages.en": "Englisch",
        "languages.it": "Italienisch",
        "languages.pl": "Polnisch",
        "languages.es": "Spanisch",
        "languages.fr": "Französisch",
        "languages.pt": "Portugiesisch",
        "languages.nl": "Niederländisch",
        "languages.cs": "Tschechisch",
        "languages.hr": "Kroatisch",
        "languages.ja": "Japanisch",
        "countries.de": "Deutschland",
        "countries.ch": "Schweiz",
        "countries.at": "Österreich",
        "countries.gb": "Großbritannien",
        "countries.en": "Großbritannien",
        "countries.us": "Vereinigte Staaten",
        "countries.it": "Italien",
        "countries.pl": "Polen",
        "countries.es": "Spanien",
        "countries.fr": "Frankreich",
        "countries.pt": "Portugal",
        "countries.nl": "Niederlande",
        "countries.be": "Belgien",
        "countries.lu": "Luxemburg",
        "countries.cz": "Tschechien",
        "countries.hr": "Kroatien",
        "countries.sk": "Slowakei",
        "countries.no": "Norwegen",
        "countries.se": "Schweden",
        "countries.fi": "Finnland",
        "countries.dk": "Dänemark",
        "countries.ie": "Irland",
        "countries.ca": "Kanada",
        "countries.au": "Australien",
        "countries.nz": "Neuseeland",
        "countries.mx": "Mexiko",
        "countries.br": "Brasilien",
        "countries.jp": "Japan"
    };
}
exports.i18n_de_de = i18n_de_de;
